import * as ActionTypes from '../action-types'

const devicesMDVR_DefaultState = {
    byID: {},
    stateByID: {},
    passengerCountByID: {},
    mdvrEventByID: {},
    disconnectedByID: {},
    playbackByTime: {},
    allIDs: []
}

export const devicesMDVR = (state = devicesMDVR_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_DEVICES_MDVR: {

            const devices = action.mobileDeviceVideoRecorders

            devices && devices.length && devices.map(device => {

                const mdvrid = device.mdvrid

                newState.byID[mdvrid] = device

                if(!newState.allIDs.includes(mdvrid)) {
                    newState.allIDs.push(mdvrid)
                }

                return null
            })

            return newState
        }
        case ActionTypes.GET_DEVICES_MDVR_STATE: {

            const devices = action.devices

            devices && devices.length && devices.map(device => {

                const mdvrid = device.DeviceId

                newState.stateByID[mdvrid] = device

                if(!newState.allIDs.includes(mdvrid)) {
                    newState.allIDs.push(mdvrid)
                }

                return null
            })

            return newState
        }
        case ActionTypes.CREATE_DEVICE_MDVR: 
        case ActionTypes.UPDATE_DEVICE_MDVR: {
            const device = action.device
            const mdvrid = device.mdvrid

            newState.byID[mdvrid] = device

            return newState
        }
        case ActionTypes.GET_PASSENGER_COUNT: {
            const passengerCount = action.passengerCount

            passengerCount && passengerCount.length && passengerCount.map(passenger => {

                const vid = passenger.vid

                if(!newState.passengerCountByID[vid]) {
                    newState.passengerCountByID[vid] = []
                }

                if(newState.passengerCountByID[vid]) {
                    newState.passengerCountByID[vid].push(passenger)
                }

                return null
            })

            return newState
        }
        case ActionTypes.GET_MDVR_EVENT: {
            const mdvrEvents = action.mdvrEvents

            mdvrEvents && mdvrEvents.length && mdvrEvents.map(mdvrEvent => {

                const vid = mdvrEvent.vid

                if(!newState.mdvrEventByID[vid]) {
                    newState.mdvrEventByID[vid] = []
                }

                if(newState.mdvrEventByID[vid]) {
                    newState.mdvrEventByID[vid].push(mdvrEvent)
                }

                return null
            })

            return newState
        }
        case ActionTypes.UNSET_MDVR_EVENT: {
            newState.mdvrEventByID = {}

            return newState
        }
        case ActionTypes.UNSET_PASSENGER_COUNT: {
            newState.passengerCountByID = {}

            return newState

        }
        case ActionTypes.GET_TIMEFRAME_TRIP_PLAYBACK_VIDEO_RECORDS: {

            const playback = action.playback

            newState.playbackByTime = {}

            playback && playback.length && playback.map((pb, i) => {

                let formattedData = {
                    key: pb.filename,
                    fileid: pb.fileid,
                    source: pb.source,
                    vid: pb.vid,
                    downloadLink: pb.downloadLink?.replace('http', 'https'),
                    playbackLink: pb.playbackLink?.replace('http', 'https'),
                    channel: 'CH' + (pb.filenameParseResult.channel || ''),
                    cameraName: pb.cameraName,
                    channelNum: pb.filenameParseResult.channel,
                    time: pb.filenameParseResult.timestampDate,
                    timeEpoch: pb.time,
                    recordType: pb.filenameParseResult.recordingType === 'Normal' ? 'Normal' : 'Alarm',
                    eventName: pb.eventName || '-',
                    lat: pb.lat,
                    lon: pb.lon,
                    durationMs: pb.filenameParseResult.durationMs
                }

                const time = formattedData.time                
                // const source = formattedData.source

                // if(source === 'device') {

                //     // testing
                //     if(!channels[time]) {
                //         channels[time] = []
                //         playbacks[time] = []
                //         downloads[time] = []
                //     }

                //     channels[time].push(formattedData.channel)
                //     playbacks[time].push(formattedData.playbackLink)
                //     downloads[time].push(formattedData.downloadLink)

                //     formattedData = { 
                //         ...formattedData, 
                //         channel: channels[time]?.join(', '),
                //         playbackLink: playbacks[time],
                //         downloadLink: downloads[time]
                //     }
                // }

                 newState.playbackByTime[`${time}#${i}`] = formattedData

                return null
            })

            return newState
        }
        case ActionTypes.GET_DEVICES_DISCONNECTED: {

            const report = action.report

            report && report.length && report.map((r) => {

                const startTime = r.startTime
                const endTime = r.endTime

                newState.disconnectedByID[`${startTime}#${endTime}`] = r

                return null
            })

            return newState
        }
        default: {
            return newState;
        }
    }
}